import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../../core/auth.service';
import { IconComponent } from '../icon/icon.component';

/** Issue #17 - shown on entry (and whenever a request is refused with ORGANIZATION_SUSPENDED) while the user's
 * organization is suspended. Not dismissable: every action is refused server-side until it is reactivated. */
@Component({
  selector: 'app-suspended-banner',
  standalone: true,
  imports: [TranslatePipe, IconComponent],
  template: `
    @if (auth.organizationSuspended()) {
      <div class="suspended" role="alert" data-testid="organization-suspended-notice">
        <app-icon name="x" [size]="16" />
        <span>{{ 'shared.organizationSuspended' | translate }}</span>
      </div>
    }
  `,
  styles: [
    `
      .suspended {
        display: flex;
        align-items: center;
        gap: var(--space-12);
        padding: 10px 20px;
        background: var(--critical-soft);
        color: var(--critical);
        border-bottom: 1px solid var(--critical);
        font-family: var(--font-display);
        font-size: 0.85rem;
      }
    `
  ]
})
export class SuspendedBannerComponent {
  readonly auth = inject(AuthService);
}
